import React from 'react';
import Panel from '../../../panel';
import { colors } from '../../../../style';
import { H5 } from '../../../title';
import { IslandsSwitch } from '../islands-switch';
import { Logo } from '../logo';

export const TOP_NAVBAR_HEIGHT = 80;

type Props = {
  children?: React.ReactNode;
};

function TopNavbar({ children }: Props) {
  return (
    <Panel
      variant={'white'}
      height={TOP_NAVBAR_HEIGHT}
      padding={'sm'}
      style={{
        borderBottom: `1px solid ${colors.gray300}`,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
      }}
      display={'flex'}
      alignItems={'center'}
      componentClass={'header'}
      justifyContent={'space-between'}
    >
      {children}
    </Panel>
  );
}

TopNavbar.IslandsSwitch = IslandsSwitch;
TopNavbar.Logo = Logo;
TopNavbar.ProductName = H5;
export { TopNavbar };
